export default [
  // {
  //   name: 'editRoute',
  //   label: 'labels.editRoute',
  //   permissionKey: 'edit_route'
  // }

  {
    name: 'routeManagement',
    label: 'labels.routeManagement',
    permissionKey: 'route_management',
    children: [
      {
        name: 'route_add',
        label: 'labels.addRoute',
        permissionKey: 'route_add'
      },
      {
        name: 'route_edit',
        label: 'labels.editRoute',
        permissionKey: 'route_edit'
      },
      {
        name: 'route_delete',
        label: 'labels.deleteRoute',
        permissionKey: 'route_delete'
      },
      {
        name: 'route_archive',
        label: 'labels.archiveRoute',
        permissionKey: 'route_archive'
      }
    ]
  }
]
